import colors from '@rategravity/frontend/theme/colors';
import React from 'react';
import TextRatesButton from '../../../components/text-rates-button';
import YouCanBookMeButton from '../../../components/you-can-book-me';

const style = {
  container: {
    textAlign: 'center',
    color: colors.primary
  },
  continue: {
    backgroundColor: colors.tertiary,
    maxWidth: 264
  },
  review: {
    paddingLeft: '1.5em',
    textAlign: 'left',
    display: 'inline-block',
    margin: '0 auto'
  },
  bullet: {
    padding: '.25em'
  }
};

const Dashboard = ({
  textRatesExperiment,
  message,
  purpose,
  advisor,
  prefill,
  reviewItems,
  actionPipe,
  steps
}) => (
  <div>
    {message}
    <br />
    {steps}
    <br />
    <div>
      <YouCanBookMeButton
        advisor={advisor}
        purpose={purpose}
        prefill={prefill}
        actionPipe={actionPipe}
      >
        SCHEDULE 7 MINUTE CALL
      </YouCanBookMeButton>
      {textRatesExperiment ? (
        <div>
          <TextRatesButton textRatesExperiment={textRatesExperiment} actionPipe={actionPipe}>
            TEXT ME MY RATES
          </TextRatesButton>
        </div>
      ) : null}
      <br />
      <br />
      <p style={style.bullet}>What we&apos;ll review on the call:</p>
      <ul style={style.review}>
        {reviewItems.map((bullet, b) => (
          <li style={style.bullet} key={b}>
            {bullet}
          </li>
        ))}
      </ul>
      <br />
      <br />
      <br />
    </div>
  </div>
);

export default Dashboard;



// WEBPACK FOOTER //
// ./src/products/shared/consult/dashboard.js